import { getYoutubeDetailsById, getYoutubeVideos } from "@/services/extended.service";

// initial state
const state = () => ({});

// mutations
const mutations = {};

// actions
const actions = {
  async loadYoutubeDetailsById(vuexContext, vid) {
    return await getYoutubeDetailsById(vid).then((response) => {
      let data = response.data;
      return data;
    });
  },

  //video listesi
  async loadYoutubeVideos(vuexContext, searchParamModel) {
    return await getYoutubeVideos(searchParamModel).then((response) => {
      let data = response.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
